module.exports = __webpack_public_path__ + "static/img/16.4335bff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/16.jpg
// module id = aFSG
// module chunks = 16